import React from 'react';
import { TextField } from '@material-ui/core';
import styles from './Analytics.module.css';

function DateTimePicker({ dateTime, setDateTime }) {
  const handleDateAndTimeChange = (e) => {
    setDateTime(new Date(e.target.value));
  };

  return (
    <div className={styles.dateTimePickerContainer}>
      <TextField
        id="date"
        type="datetime-local"
        defaultValue={new Date(
          dateTime.getTime() - dateTime.getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 16)}
        InputProps={{
          disableUnderline: true
        }}
        InputLabelProps={{
          shrink: true
        }}
        onChange={handleDateAndTimeChange}
      />
    </div>
  );
}

export default DateTimePicker;
